var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Settings"}},[_c('div',[_c('VSettingsSidebarLayoutHeading',{attrs:{"title":"Address Validation","buttons":_vm.buttons}}),_c('div',{staticClass:"account-notifications-form__wrapper"},[_c('AccountSettingsFormAdvanced',{attrs:{"initialValues":{
          intl_validation: _vm._user && _vm._user.intl_validation,
          us_validation: _vm._user && _vm._user.us_validation
        }}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }